{
  "version": 1,
  "asset_id": "fa1d114a-e28b-4fe2-a7d0-94eb7952db66",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/fa1d114a-e28b-4fe2-a7d0-94eb7952db66/sleeve-gastrectomy-v2-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/fa1d114a-e28b-4fe2-a7d0-94eb7952db66/sleeve-gastrectomy-v2-800.webp",
  "original_filename": "sleeve-gastrectomy-v2-800.webp",
  "size": 44046,
  "content_type": "image/webp",
  "created_at": "2026-09-25T13:06:59Z"
}
